import React from 'react'
import { Button, Modal } from 'antd'
import ApplicationPaymentsDetailView from './ApplicationPaymentsDetailView'

const ApplicationPaymentsDetailModal = ({ application, showModal, onCancel }) => {
  return (
    <Modal
      title="История платежей"
      visible={showModal}
      onCancel={onCancel}
      width={1200}
      footer={[
        <Button key="back" onClick={onCancel}>
          Отмена
        </Button>,
      ]}
    >
      <ApplicationPaymentsDetailView application={application} />
    </Modal>
  )
}

export default ApplicationPaymentsDetailModal
